import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { useLoadOptions } from "src/hooks/useLoadOptions";
import { AsyncSelect, ControlledDatePicker, ControlledTextField } from "../../../../../components/forms";
import CardActions from '../../../components/CardActions';
import { SectionBox } from '../../../components/FieldView';
import { OperacionAFOCLFields } from '../types/fields';
import { FormOperacionAFOCL } from '../types/types';
import { useAFOPUSectorComercialTipos, useAFOPUUnidadNegocioTipos } from '../../afopu/hooks/useAFOPUCache';
import { OperacionAFOSectorComercialFields, OperacionAFOUnidadNegocioFields } from '../../afopu/types/fields';
import { SectorComercialFields } from 'src/types';

interface SeccionNuevoAFOCLDatosOperacionProps {
  formMethods: UseFormReturn<FormOperacionAFOCL>
  codSistemaPrincipal: number,
  codSistema: number
}

export const SeccionNuevoAFOCLDatosOperacion = ({
  formMethods,
  codSistemaPrincipal,
  codSistema
}: SeccionNuevoAFOCLDatosOperacionProps) => {
  const { control, setValue, resetField } = formMethods
  const unidadNegocioTipos = useAFOPUUnidadNegocioTipos(codSistemaPrincipal, codSistema);
  const loadUnidadNegocio = useLoadOptions({
    data: unidadNegocioTipos.unidadNegocioTipos,
    loading: unidadNegocioTipos.isLoading,
    isError: unidadNegocioTipos.isError,
    error: unidadNegocioTipos.error
  });

  const watchedUnidadNegocio = useWatch({ control: control, name: OperacionAFOCLFields.CodUnidadNegocio });

  const watchedSectorComercial = useWatch({ control: control, name: OperacionAFOCLFields.CodSectorComercial });

  const sectorComercialTipos = useAFOPUSectorComercialTipos(watchedUnidadNegocio, codSistema);
  const loadSectorComercial = useLoadOptions({
    data: sectorComercialTipos.sectorComercialTipos,
    loading: sectorComercialTipos.isLoading,
    isError: sectorComercialTipos.isError,
    error: sectorComercialTipos.error
  });

  useEffect(() => {
    // Cuando cambia la unidad de negocio, reseteamos el sector comercial y las cuentas.
    resetField(OperacionAFOCLFields.CodSectorComercial);
  }, [watchedUnidadNegocio, setValue]);

  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      <SectionBox>

        <Grid item xs={12} md={4}>
          <AsyncSelect
            name={OperacionAFOCLFields.CodUnidadNegocio}
            loadOptions={loadUnidadNegocio}
            valueField={SectorComercialFields.UnidadNegocioCodigo}
            control={control}
            label='Unidad de negocio'
            selectNotNulleable
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <AsyncSelect
            name={OperacionAFOCLFields.CodSectorComercial}
            loadOptions={loadSectorComercial}
            valueField={SectorComercialFields.SectorComercialCodigo}
            control={control}
            label='Equipo Comercial'
            selectNotNulleable
            disabled={!watchedUnidadNegocio}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <ControlledTextField
            control={control}
            name={OperacionAFOCLFields.RazonSocial}
            label='Razón Social'
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <ControlledTextField
            control={control}
            name={OperacionAFOCLFields.NumeroCuenta}
            label='Número de Cuenta Comitente'
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <ControlledDatePicker
            name={OperacionAFOCLFields.FechaSolicitud}
            control={control}
            label='Fecha Solicitud'
            disabled
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <ControlledDatePicker
            name={OperacionAFOCLFields.FechaVencimiento}
            control={control}
            label='Fecha Vencimiento'
          />
        </Grid>

        <Grid item xs={12}>
          <ControlledTextField
            control={control}
            name={OperacionAFOCLFields.Observaciones}
            label='Observaciones'
            multiline={true}
            minRows={3}
            fullWidth
          />
        </Grid>
      </SectionBox>
    </CardActions>
  )
}
